import { actionCreator, namespacedActionCreator } from '@ardoq/rxbeach';
import { EphemeralNotificationOutcome } from '@ardoq/api-types';
import {
  EphemeralNotificationKeys,
  type EphemeralNotificationInteraction,
  type TrackableNotificationConfig,
} from './types';

export type EphemeralNotificationRenderedPayload = {
  notificationKey: EphemeralNotificationKeys;
};

/** How the user left the notification. */
export type EphemeralNotificationResolution = Extract<
  EphemeralNotificationOutcome['status'],
  'dismissed' | 'completed'
>;

export type EphemeralNotificationResolutionPayload = {
  notificationKey: EphemeralNotificationKeys;
  resolution: EphemeralNotificationResolution;
};

export const addEphemeralNotificationResolution =
  namespacedActionCreator<EphemeralNotificationResolutionPayload>(
    '[EPHEMERAL_NOTIFICATION] ADD_RESOLUTION'
  );
export const ephemeralNotificationRendered =
  namespacedActionCreator<EphemeralNotificationRenderedPayload>(
    '[EPHEMERAL_NOTIFICATION] NOTIFICATION_RENDERED'
  );
export type EphemeralNotificationViewedPayload = {
  config: TrackableNotificationConfig;
};

/** A view that met the dwell threshold. */
export const ephemeralNotificationViewed =
  actionCreator<EphemeralNotificationViewedPayload>(
    '[EPHEMERAL_NOTIFICATION] NOTIFICATION_VIEWED'
  );

export type EphemeralNotificationInteractedPayload = {
  config: TrackableNotificationConfig;
  interaction: EphemeralNotificationInteraction;
};

export const ephemeralNotificationInteracted =
  actionCreator<EphemeralNotificationInteractedPayload>(
    '[EPHEMERAL_NOTIFICATION] NOTIFICATION_INTERACTED'
  );
